import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../Button';
import { ButtonLoader } from '../../ButtonLoader';

export class Opinion extends Component {
	constructor(props) {
		super(props);
	}
	render() {
		const { comments = false, disabled = false, agreementAcceptedRequired = false, agreementAccepted = false, scrollToAgreement = Function.prototype } = this.props;
		const isExecuting =
			this.props.opinionExecuting.findIndex(
				(id) => id === this.props.commentObjectId || id === this.props.userOpinionId
			) !== -1;

		return (
			<Fragment>
				{isExecuting && (
					<ButtonLoader
						small={comments}
						variant="danger"
						disabled={isExecuting}
						isExecuting={isExecuting}
						executingText={'Zapisywanie'}
					/>
				)}
				{!isExecuting && (
					<div className="links">
						{this.props.userLikeCount == 0 && (
							<a
								className={`link link--success link__icon-bigger${disabled ? ' link--secondary':''}`}
								onClick={() => {
									if (disabled) {
										return false;
									}
									if (agreementAcceptedRequired && !agreementAccepted) {
										if (scrollToAgreement !== Function.prototype) {
											scrollToAgreement();
											return false;
										}
										return alert('Wymagana akceptacja regulaminu');
									}
									this.props.addOpinion(this.props.commentObjectId, 0);
								}}
								title={`${disabled ? 'Nieaktywny przycisk dodaj pozytywną opinię':'Dodaj pozytywną opinię'}`}
								disabled={isExecuting || disabled}
							>
								<i className="far fa-thumbs-up" /> {`(${this.props.likeCount})`}
							</a>
						)}
						{this.props.userLikeCount == 1 && (
							<a
								className={`link link--success link__icon-bigger${disabled ? ' link--secondary':''}`}
								onClick={() => {
									if (disabled) {
										return false;
									}
									if (agreementAcceptedRequired && !agreementAccepted) {
										if (scrollToAgreement !== Function.prototype) {
											scrollToAgreement();
											return false;
										}
										return alert('Wymagana akceptacja regulaminu');
									}
									this.props.removeOpinion(this.props.userOpinionId);
								}}
								title={`${disabled ? 'Nieaktywny przycisk usuń pozytywną opinię':'Usuń pozytywną opinię'}`}
								disabled={isExecuting||disabled}
							>
								<i className="fas fa-thumbs-up" /> {`(${this.props.likeCount})`}
							</a>
						)}
						{this.props.userUnlikeCount == 0 && (
							<a
								className={`link link--danger link__icon-right link__icon-bigger${disabled ? ' link--secondary':''}`}
								onClick={() => {
									if (disabled) {
										return false;
									}
									if (agreementAcceptedRequired && !agreementAccepted) {
										if (scrollToAgreement !== Function.prototype) {
											scrollToAgreement();
											return false;
										}
										return alert('Wymagana akceptacja regulaminu');
									}
									this.props.addOpinion(this.props.commentObjectId, 1);
								}}
								title={`${disabled ? 'Nieaktywny przycisk dodaj negatywną opinię':'Dodaj negatywną opinię'}`}
								disabled={isExecuting||disabled}
							>
								<i className="far fa-thumbs-down" /> {`(${this.props.unlikeCount})`}
							</a>
						)}
						{this.props.userUnlikeCount == 1 && (
							<a
								className={`link link--danger link__icon-right link__icon-bigger${disabled ? ' link--secondary':''}`}
								onClick={() => {
									if (disabled) {
										return false;
									}
									if (agreementAcceptedRequired && !agreementAccepted) {
										if (scrollToAgreement !== Function.prototype) {
											scrollToAgreement();
											return false;
										}
										return alert('Wymagana akceptacja regulaminu');
									}
									this.props.removeOpinion(this.props.userOpinionId);
								}}
								title={`${disabled ? 'Nieaktywny przycisk usuń negatywną opinię':'Usuń negatywną opinię'}`}
								disabled={isExecuting||disabled}
							>
								<i className="fas fa-thumbs-down" /> {`(${this.props.unlikeCount})`}
							</a>
						)}
					</div>
				)}
			</Fragment>
		);
	}
}

Opinion.propTypes = {
	commentObjectId: PropTypes.number,
	likeCount: PropTypes.number,
	unlikeCount: PropTypes.number,
	userLikeCount: PropTypes.number,
	userUnlikeCount: PropTypes.number,
	userOpinionId: PropTypes.number,

	addOpinion: PropTypes.func,
	removeOpinion: PropTypes.func
};

Opinion.defaultProps = {
	commentObjectId: 0,
	likeCount: 0,
	unlikeCount: 0,
	userLikeCount: 0,
	userUnlikeCount: 0,
	userOpinionId: 0,
	opinionExecuting: false,

	addOpinion: Function.prototype,
	removeOpinion: Function.prototype
};
